// extracted by mini-css-extract-plugin
export default {"SectionTitle":"styles_SectionTitle__rN2uM","note":"styles_note__RO9PH","info":"styles_info__u4nBo","column":"styles_column__X50Nd"};